<div class="crossIcon" (click)="action()">
  <ion-icon name="close-outline"></ion-icon>
</div>
<ion-content class="content">
  <div class="content">
    <div class="header">
      <p>{{'ScheduleautoAssign'|language:'Schedule auto assign'}}</p>
    </div>
    <ion-grid>
      <ion-row class="scheduling">
        <ion-col class="options" *ngFor="let o of schedulingOptions; let i = index"
          (click)="selectSchedule(o.value, i)">
          <div class="opt" [class.active]="selectedIndex == i">
            <img [src]="o.img" alt="">
            <p class="txt">{{o.option | language: o.option}}</p>
          </div>
        </ion-col>
      </ion-row>
      <ion-row class="scheduling" *ngIf="selectedIndex === 1">
        <ion-col class="options" *ngFor="let o of schedulingOptions[1].subOption; let i = index"
          (click)="selectSubSchedule(o.value, i)">
          <div class="opt" [class.active]="selectedIndexSubOptIndex == i">
            <p class="txt">{{o.optName | language: o.optName}}</p>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
  <!-- <ion-button shape="round" fill="clear" expand="block" class="schedule-btn"
        (click)="scheduleAutoAssign()">{{'Schedule' |
        language : 'Schedule'}}
    </ion-button> -->
</ion-content>